// extracted by mini-css-extract-plugin
export default {"container":"EnergyKwhMini_container__91Kc3","value":"EnergyKwhMini_value__BXMb4","unit":"EnergyKwhMini_unit__pJSd2"};